import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { USERTYPES } from "../../../constants/Constants";
import { Icon } from "@fluentui/react";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import { getEnv } from "../../../helpers/EnvHelper";

const ColumnSubModality = (handleClickGroup, userRole, handleEdit) => {
  const [t, i18n] = useTranslation();

  const childTrPadding =
    getEnv("REACT_APP_HYBRID_MODE") == "false"
      ? "15px 0px 15px 10px"
      : "15px 10px";
  const rowTrPadding = "0px 10px";

  return [
    {
      id: "serviceCode",
      style: { width: "8vw", boxSizing: "border-box", padding: rowTrPadding },
      headerStyle: {
        padding: "15px 0px 15px 10px",
        textAlign: "left",
        boxSizing: "border-box",
      },
      headerClass: "break-word column-sub-modality-service-serviceCode-header",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Service Code</span>,
      accessor: "serviceCode",
      accessorKey: "serviceCode",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-sub-heading">
              {cell.row.original.serviceCode}
            </div>
          </div>
        </>
      ),
    },
    {
      id: "modalityName",
      style: { width: "5vw", boxSizing: "border-box", padding: rowTrPadding },
      headerStyle: {
        padding: "15px 0px 15px 10px",
        textAlign: "left",
        boxSizing: "border-box",
      },
      headerClass: "break-word column-sub-modality-service-modality-header",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Modality</span>,
      accessor: "modalityName",
      accessorKey: "modalityName",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-sub-heading">
              {cell.row.original.modalityName}
            </div>
          </div>
        </>
      ),
    },
    {
      id: "serviceName",
      style: { width: "20vw", boxSizing: "border-box", padding: rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "60vw",
        boxSizing: "border-box",
      },
      headerClass: "break-word column-sub-modality-service-name-header",
      classChildName:
        "break-word cursor-pointer column-sub-modality-service-name-header",
      header: () => <span className="">Service Name</span>,
      accessor: "serviceName",
      accessorKey: "serviceName",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-sub-heading">
              {cell.row.original.serviceName}
            </div>
          </div>
        </>
      ),
    },

    {
      id: "expirationTime",
      style: { width: "12vw", boxSizing: "border-box", padding: rowTrPadding },
      headerStyle: {
        padding: "15px 0px 15px 10px",
        textAlign: "left",
        boxSizing: "border-box",
      },
      headerClass:
        "break-word column-sub-modality-service-expiration-time-header",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Expiration Time(mins)</span>,
      accessor: "expirationTime",
      accessorKey: "expirationTime",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-sub-heading">
              {cell.row.original.expirationTime
                ? cell.row.original.expirationTime
                : "-"}
            </div>
          </div>
        </>
      ),
    },
    {
      id: "action",
      style: { width: "5vw", boxSizing: "border-box", padding: rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "40vw !important",
        boxSizing: "border-box",
      },
      headerClass: "break-word column-firm-type-header",
      classChildName:
        "break-word cursor-pointer column-sub-modality-service-action-header",
      header: () => <span className="">Actions</span>,
      accessor: "action",
      accessorKey: "action",
      show: true,
      cell: (cell) => (
        <>
          <div style={{ width: "20%", alignItems: "center", display: "flex" }}>
            <CustomToolTipHost content={"Edit"} id={"tooltip_"}>
              <Icon
                iconName="Edit"
                style={{
                  // color: "white",
                  fontSize: 17,
                  lineHeight: "44px",
                  marginRight: "15px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  console.log("In the column ---->", cell);
                  handleEdit(cell.row.original);
                }}
              ></Icon>
            </CustomToolTipHost>
          </div>
        </>
      ),
    },
  ];
};
export default ColumnSubModality;
